// TODO: Resolve type errors across library boundaries
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import styled from 'styled-components';
import { FormattedReactMessage, FormattedMessage } from '@99designs/frontend-components/i18n';
import { colors } from '../../../../shared/lib/styles';
import Paragraph from '../../../../shared/components/Paragraph';
import { ChameleonLink } from '../../../../shared/components/Link';
import Currency from '../../I18n/Currency';
import { getLogoPrice, stringContainsPrice } from '../LogoDesignPricing/helpers';
import type { Currency as CurrencyCode } from '../../../../shared/lib/currency';
import type { Message } from './FAQSection';
import { ItemData } from '../../../../shared/components/SearchableAccordion';
const StyledParagraph = styled(Paragraph)`
    color: ${colors.grey800};
`;

const getLinkReplacements = (message: Message, index: number) => {
    const replacements = {};

    Object.keys(message.links).forEach(
        (key) => (replacements[key] = <ChameleonLink href={message.links[key]} />)
    );

    return (
        <StyledParagraph key={index}>
            <FormattedReactMessage key={index} message={message.copy} replacements={replacements} />
        </StyledParagraph>
    );
};

export const getFAQs = (questions, currency: CurrencyCode): ItemData[] =>
    questions.map((question) => {
        return {
            id: question.id,
            title: question.title,
            keywords: question.keywords,
            messages: question.messages.map((message) => message.copy),
            render() {
                return question.messages.map((message, index) => {
                    if (message.links && !stringContainsPrice(message.copy)) {
                        return getLinkReplacements(message, index);
                    }

                    return (
                        <StyledParagraph>
                            <FormattedMessage
                                message={message.copy}
                                values={{
                                    fromPrice: (
                                        <Currency
                                            value={getLogoPrice('base-option', currency)}
                                            currency={currency}
                                            hideDecimal
                                        />
                                    ),
                                    maxLogoPriceInFaqs: (
                                        <Currency
                                            value={getLogoPrice('max-logo-price-faqs', currency)}
                                            currency={currency}
                                            hideDecimal
                                        />
                                    ),
                                }}
                            />
                        </StyledParagraph>
                    );
                });
            },
        };
    });

export const getSchemaFAQs = (questions): ItemData[] =>
    questions.map((question) => {
        return {
            id: question.id,
            title: question.title,
            keywords: question.keywords,
            messages: question.messages.map((message) => message.copy),
            render() {
                return question.messages.map((message, index) => {
                    if (message.links && !stringContainsPrice(message.copy)) {
                        return getLinkReplacements(message, index);
                    }

                    return (
                        <StyledParagraph>
                            {__(
                                'There’s a wide price range for logos, from almost free to US$10,000 or more. On 99designs, you can get a professionally designed logo from US$299.'
                            )}
                        </StyledParagraph>
                    );
                });
            },
        };
    });
